import { render } from "./EmployeesTable.vue?vue&type=template&id=3d7fbafe&ts=true"
import script from "./EmployeesTable.vue?vue&type=script&lang=ts"
export * from "./EmployeesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__